import { GraphQLClient } from 'graphql-request'
import { logger } from '@logger'
import { INTERNAL_CONSTANTS } from '@constants/internalConstants'
import { environmentConfigurations } from '@configurations/environmentConfigurations'
import store from '../../store/store'

const { NETWORK_CLIENT, API } = INTERNAL_CONSTANTS
const { GRAPHQL } = NETWORK_CLIENT
const { MESSAGES, LABELS } = API

export const graphQLClient = async ({ query, variables = {}, isAuthRequired = false }) => {
  const headers = {}

  if (isAuthRequired) {
    const token = store.getState().session?.details?.accessToken
    if (token) {
      headers.Authorization = `Bearer ${token}`
    } else {
      logger.error(GRAPHQL, LABELS.ERROR, 'Auth required but no token found in session')
    }
  }

  const client = new GraphQLClient(environmentConfigurations.crashGameGraphqlBaseURL, { headers })

  try {
    logger.api(GRAPHQL, LABELS.REQUEST, { query, variables })

    const data = await client.request(query, variables)

    logger.success(GRAPHQL, LABELS.RESPONSE, data)

    return data
  } catch (error) {
    logger.error(GRAPHQL, LABELS.ERROR, error)

    // Surface a real Error so callers (services / TanStack Query) get a clean
    // message instead of tripping over an undefined success payload downstream.
    const graphQLError = new Error(
      error?.response?.errors?.[0]?.message || error.message || MESSAGES.ERROR
    )
    graphQLError.status = error?.response?.status
    throw graphQLError
  }
}
